var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMiniCalendar),expression:"showMiniCalendar"}],staticClass:"pb-mini-calendar"},[_c('full-calendar',{ref:"mini-calendar",attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ecca70","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MiniCalendar.vue
// module id = 474
// module chunks = 1